import { css } from "@emotion/css";
import { text, themeTokens } from "@octopusdeploy/design-system-tokens";

export const SmallScreen = "600px";

export const dataTable = css({
    borderCollapse: "collapse",
    width: "100%",
    font: text.body.regular.medium,
    [`@media (max-width: ${SmallScreen})`]: {
        border: "none",
        display: "block",
    },
});

export const dataTableHeader = css({
    [`@media (max-width: ${SmallScreen})`]: {
        display: "block",
    },
});

export const dataTableHeaderColumn = css({
    color: themeTokens.color.text.secondary,
    padding: "1rem 1.125rem",
    font: text.body.regular.medium,
    boxSizing: "border-box",
    textAlign: "left",
    [`@media (max-width: ${SmallScreen})`]: {
        display: "block",
    },
});

export const dataTableFooterColumn = css({
    color: themeTokens.color.text.secondary,
    padding: 0,
    font: text.body.regular.medium,
    paddingBottom: "1rem",
    textAlign: "left",
    boxSizing: "border-box",
    [`@media (max-width: ${SmallScreen})`]: {
        display: "block",
    },
});

//Intentionally left blank to generate className which is used to
//control the tools row behaviour at small screen sizes.
export const dataTableToolsRow = css({});

export const dataTableRow = css({
    [`thead &`]: {
        border: "none",
        ":hover, :focus": {
            backgroundColor: "transparent",
        },
    },
    borderTop: `0.0625rem solid ${themeTokens.color.border.primary}`,

    ":last-child": {
        borderBottom: `0.0625rem solid ${themeTokens.color.border.primary}`,
    },
    [`@media (max-width: ${SmallScreen})`]: {
        display: "block",

        [`thead &:not(.${dataTableToolsRow})`]: {
            position: "absolute",
            top: "-9999px",
            left: "-9999px",
        },
    },
});

export const dataTableRowHeaderColumn = css({
    verticalAlign: "top",
    paddingTop: "0.875rem",
    textAlign: "right",
    width: "16rem",
    [`@media (max-width: ${SmallScreen})`]: {
        padding: "0.75rem 1.125rem",
        textAlign: "left",
        width: "unset",
    },
});

export const dataTableRowHeaderColumnInSidebar = css({
    width: "8rem !important",
    [`@media (max-width: ${SmallScreen})`]: {
        width: "unset",
    },
});

export const dataTableRowColumn = css({
    boxSizing: "border-box",
    color: themeTokens.color.text.primary,
    verticalAlign: "top",
    padding: "0.75rem 1.125rem",

    "&:first-child": {
        font: text.body.bold.medium,
    },

    a: {
        textAlign: "left",
        color: themeTokens.color.text.link.default,
    },
    [`@media (max-width: ${SmallScreen})`]: {
        display: "block",
        border: "none",
        position: "relative",
        lineHeight: "1.5rem",
        paddingTop: "0.5rem",
        paddingBottom: 0,
        maxWidth: "100%",
        width: "100%",
        "&:not(:first-child)": {
            paddingTop: 0,
        },
    },
});
